import styled, { css } from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

import { TextButton } from '@sharedComponents/Buttons';

const FormattedMessageText = css`
  div {
    display: inline;
  }
`;

export const StyledTitle = styled.div`
  ${FormattedMessageText};
  font-weight: bold;
`;

export const StyledTitleLink = styled(TextButton)`
  font-weight: bold;
  line-height: inherit;
`;

export const StyledDescription = styled.div`
  margin-top: 0.25rem;
  color: ${theme.color.text.tertiary};
  ${FormattedMessageText};
`;
